import { render } from "./PartnersByStatusChart.vue?vue&type=template&id=71afc25f&scoped=true"
import script from "./PartnersByStatusChart.vue?vue&type=script&lang=js"
export * from "./PartnersByStatusChart.vue?vue&type=script&lang=js"

import "./PartnersByStatusChart.vue?vue&type=style&index=0&id=71afc25f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71afc25f"

export default script